import { render, staticRenderFns } from "./IdentifyCustomers.vue?vue&type=template&id=fac7fee4&scoped=true&"
import script from "./IdentifyCustomers.vue?vue&type=script&lang=ts&"
export * from "./IdentifyCustomers.vue?vue&type=script&lang=ts&"
import style0 from "./IdentifyCustomers.vue?vue&type=style&index=0&id=fac7fee4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac7fee4",
  null
  
)

export default component.exports